import { ContentCopyOutlined } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'

interface CopyAnswerButtonProps {
  text: string
}

export const CopyAnswerButton: React.FC<CopyAnswerButtonProps> = ({ text }) => {
  const { formatMessage } = useIntl()
  const [copied, setCopied] = useState(false)

  const copy = async () => {
    await navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <Tooltip title={formatMessage({ id: copied ? 'general.copied' : 'general.copyToClipboard' })} arrow>
      <IconButton size="small" onClick={copy} sx={{ color: 'grey.600' }} data-testid="copy-ai-answer">
        <ContentCopyOutlined fontSize="small" />
      </IconButton>
    </Tooltip>
  )
}
